import INC_BASE_API from 'apis/incentivio-api';
import { useURLSearchParams } from 'hooks/useURLSearchParams';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

export const useOptOutEmail = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const pref = useURLSearchParams().get('pref');

  const optOutEmail = async () => {
    setLoading(true);
    try {
      await INC_BASE_API.get(`/updateemailpref?pref=${pref}`);
      setSuccess(true);
    } catch (err) {
      const { status } = err?.response;

      const errorMessageTitle = t(
        `optOut.${status === 400 ? 'errors.invalid' : 'errors.common'}.title`,
      );
      const errorMessageDesc = t(
        `${
          status === 400
            ? 'optOut.errors.invalid.description'
            : 'errors.genericError'
        }`,
      );

      toast.error(`${errorMessageTitle}: ${errorMessageDesc}`);
    } finally {
      setLoading(false);
    }
  };

  return { success, loading, optOutEmail };
};
